export default "__VITE_ASSET__4clvUgoo__"